























import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import InstallationsStatusSummary from "./InstallationsStatusSummary.vue";
import StatusMainTable from "./StatusMainTable.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchInstallationsStatusResponse } from "@/model/communication/status/FetchInstallationsStatusResponse";
import { FetchInstallationsStatusCommand, GetDevicesStatusReqData } from "@/model/communication/status/FetchInstallationsStatusCommand";

export default Vue.extend({
    components: {
        StandardPage,
        InstallationsStatusSummary,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            StatusMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            totalsByStatus: [],
            filteredTotalsByStatus: [],
            totalsByConnectivityStatus: [],
            filteredTotalsByConnectivityStatus: [],
            loading: false,
            loadingSummary: false,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.loadingSummary = true;
                this.loading = true;
                this.reqData = request;
                let response: FetchInstallationsStatusResponse = await new FetchInstallationsStatusCommand(request).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                    this.totalsByStatus = response.totalCountByStatus;
                    this.filteredTotalsByStatus = response.filteredTotalCountByStatus;
                    this.totalsByConnectivityStatus = response.totalCountByConnectivityStatus;
                    this.filteredTotalsByConnectivityStatus = response.filteredTotalCountByConnectivityStatus;
                }
            } catch (e) {
                console.log("Something went wrong sending GetInstallationsEnabledModules request ", e);
            }
            this.loading = false;
            this.loadingSummary = false;
        },

        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
    mounted() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            this.reqData = JSON.parse(atob(this.$route.query.reqData));
        } else {
            this.reqData = new GetDevicesStatusReqData();
            this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        }
    },
});
